
























































































































































































































































































































































































import { Component, PropSync, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ReservationAccUnitModel,
  ReservationModel,
  ChangeRatePlanEvent,
  ChangeServiceTypeEvent,
  SelectedRatePlanModel,
} from "./types";
import { getUnitOwnerIds } from "./functions";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import { saveFile } from "@/shared/saveFile";
import ReservationFormUnitGuests from "@/components/reservation-form/ReservationFormUnitGuests.vue";
import ReservationFormUnitFields from "@/components/reservation-form/ReservationFormUnitFields.vue";
import ReservationFormUnitAddOnServices from "@/components/reservation-form/ReservationFormUnitAddOnServices.vue";
import RatePlanSelectModal from "@/components/calendar/RatePlanSelectModal.vue";
import ServiceTypeSelectModal from "@/components/reservation-form/ServiceTypeSelectModal.vue";
import { Action, Getter } from "vuex-class";
import { FinancialSettingsType } from "@/store/modules/financial";
import { JwtClaims } from "@/store/modules/auth";
import { policyChecker } from "@/shared/roles";
import { SalesChannelView } from "@/shared/models/salesChannel";
import { ServiceType } from "@/shared/models/serviceType";
import {
  CurrencyConversionService,
  currencyConversionServiceFactory,
} from "@/shared/currencyConversionService";
import { differenceInDays } from "@/shared/dateFormatUtils";
import _ from "lodash";
import { reservationStatuses } from "@/shared/models/vReservation";
import { AppParam, AppParamsEnum } from "@/shared/models/appParam";
import { RatePlanModel } from "@/components/reservation-form/types";
import {
  AccomodationUnitStatusEnum,
  DistributionChannelEnum,
} from "@/shared/models/enums.type";
import { AccomodationUnitStatus } from "@/shared/models/accomodationUnitStatus";
import { round } from "@/components/numbers/numberFormatUtils";

type ExportRegistrationFormOptions = {
  reservationFormBlankPrice: boolean;
};

@Component({
  components: {
    NumericInputImproved,
    CurrencyDisplay,
    ReservationFormUnitGuests,
    ReservationFormUnitFields,
    ReservationFormUnitAddOnServices,
    RatePlanSelectModal,
    ServiceTypeSelectModal,
  },
})
export default class ReservationFormUnitTile extends Vue {
  @PropSync("reservation") reservationModel?: ReservationModel;
  @PropSync("overbooked") isOverbooked?: number[];
  @PropSync("notAvailable") isNotAvailable?: number[];
  @PropSync("unit", { default: undefined }) model?: ReservationAccUnitModel;
  @Prop({ default: true }) isEditingReservation?: boolean;
  @Prop() serviceTypes?: ServiceType[];
  @Prop() isFromCalendar?: boolean;
  @Prop() isFromAvailabilitySearch?: boolean;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;
  @Getter("financial/settings") financialSettings?: FinancialSettingsType;
  @Getter("language/language") language?: string;

  @Action("codebooks/refreshSalesChannels")
  refreshSalesChannels?: () => Promise<void>;
  @Getter("codebooks/salesChannels") salesChannels?: SalesChannelView[];

  @Getter("appParams/unitRenderTypeLineOne") renderTemplateTypeLineOne?: string;
  @Getter("appParams/unitRenderTypeLineTwo") renderTemplateTypeLineTwo?: string;
  @Getter("appParams/reservationHideDiscount")
  reservationHideDiscount?: boolean;
  @Getter("appParams/showRegistrationFormButton")
  showRegistrationFormButton?: boolean;

  @Getter("appParams/showPAXSuffixInRatePlanName")
  showPAXSuffixInRatePlanName?: boolean;
  @Getter("appParams/showLOSSuffixInRatePlanName")
  showLOSSuffixInRatePlanName?: boolean;

  @Getter("appParams/appParams") appParams?: AppParam[];

  @Getter("codebooks/accomodationUnitStatuses")
  accomodationUnitStatuses?: AccomodationUnitStatus[];

  @Getter("appParams/tenantOBRsUseRelativePricing")
  tenantOBRsUseRelativePricing?: boolean;
  @Getter("appParams/tenantCanEditLOSCategories")
  tenantCanEditLOSCategories?: boolean;
  @Getter("appParams/tenantCanEditPAXCategories")
  tenantCanEditPAXCategories?: boolean;
  @Getter("appParams/tenantAutomaticPAXCategoriesAreIndividual")
  tenantAutomaticPAXCategoriesAreIndividual?: boolean;

  @Getter("appParams/childrenAffectPAXRatePlanSelection")
  childrenAffectPAXRatePlanSelection?: boolean;

  @Getter("appParams/tenantUsesInputPrice")
  tenantUsesInputPrice?: boolean;

  addOnServicesFormOpen = false;

  @Watch("reservationModel.numberOfAdults")
  numberOfAdultsChanged() {
    if (
      this.reservationModel?.numberOfUnits != null &&
      this.reservationModel.numberOfUnits <= 1 &&
      this.reservationModel?.accomodationUnitTypes.length == 1 &&
      this.reservationModel.numberOfAdults != null
    ) {
      this.reservationModel.accomodationUnitTypes[0].numberOfAdults =
        this.reservationModel.numberOfAdults;
    }
  }

  @Watch("reservationModel.numberOfChildren")
  numberOfChildrenChanged() {
    if (
      this.reservationModel?.numberOfUnits != null &&
      this.reservationModel.numberOfUnits <= 1 &&
      this.reservationModel?.accomodationUnitTypes.length == 1 &&
      this.reservationModel.numberOfChildren != null &&
      this.reservationModel.childrenAges
    ) {
      this.reservationModel.accomodationUnitTypes[0].numberOfChildren =
        this.reservationModel.numberOfChildren;
      if (
        !this.reservationModel.numberOfChildren ||
        this.reservationModel.numberOfChildren <= 0
      ) {
        this.reservationModel.accomodationUnitTypes[0].childrenAges = [];
        return;
      }

      while (
        this.reservationModel.accomodationUnitTypes[0].childrenAges.length <
        this.reservationModel.numberOfChildren
      ) {
        this.reservationModel.accomodationUnitTypes[0].childrenAges.push(0);
      }

      while (
        this.reservationModel.accomodationUnitTypes[0].childrenAges.length >
        this.reservationModel.numberOfChildren
      ) {
        this.reservationModel.accomodationUnitTypes[0].childrenAges.pop();
      }
    }
  }

  @Watch("reservationModel.childrenAges", { deep: true })
  agesChanged() {
    if (
      this.reservationModel?.numberOfUnits != null &&
      this.reservationModel.numberOfUnits <= 1 &&
      this.reservationModel?.childrenAges &&
      this.reservationModel?.accomodationUnitTypes.length == 1
    ) {
      for (
        let index = 0;
        index < this.reservationModel?.childrenAges.length;
        index++
      ) {
        //assigining values directly would not update the reactively rendered components in child (ReservationFormUnitGuests) v-for
        Vue.set(
          this.reservationModel.accomodationUnitTypes[0].childrenAges,
          index,
          this.reservationModel?.childrenAges[index]
        );
      }
    }
  }

  get obRatePlanFactors() {
    return {
      numberOfAdults: this.model?.numberOfAdults ?? 0,
      numberOfChildren: this.model?.numberOfChildren ?? 0,
      numberOfNights: this.numberOfNights,
    };
  }

  get ratePlanLockSuffix() {
    return (this.tenantCanEditPAXCategories ||
      this.tenantAutomaticPAXCategoriesAreIndividual) &&
      !this.tenantCanEditLOSCategories
      ? ".PAX"
      : this.tenantCanEditLOSCategories && !this.tenantCanEditPAXCategories
      ? ".LOS"
      : this.tenantCanEditPAXCategories && this.tenantCanEditLOSCategories
      ? ".PAXLOS"
      : ".PAX"; //default if tenants doesnt use official rates are OB or LOS based ("pravila popunjenosti")
  }

  get feeCalculationFactors() {
    return {
      numberOfAdults: this.model?.numberOfAdults ?? 0,
      numberOfChildren: this.model?.numberOfChildren ?? 0,
      numberOfNights: this.numberOfNights,
      arrivalDate: this.model?.arrivalDate,
      departureDate: this.model?.departureDate,
      ratePlan: this.model?.ratePlan,
      comission: this.model?.channelCommission,
    };
  }

  @Watch("obRatePlanFactors", { deep: true })
  unitNumberOfAdultsChanged(
    fresh: {
      numberOfAdults: number;
      numberOfChildren: number;
      numberOfNights: number;
    },
    old?: {
      numberOfAdults: number;
      numberOfChildren: number;
      numberOfNights: number;
    }
  ) {
    if (_.isEqual(fresh, old)) {
      return;
    }
    const numberOfPeople =
      fresh.numberOfAdults +
      (this.childrenAffectPAXRatePlanSelection ? fresh.numberOfChildren : 0);
    if (
      this.model &&
      this.model.ratePlan &&
      !this.model.userSetPricePerNightManually &&
      !this.model.manuallyChangedRatePlan
    ) {
      const currentMainRatePlanId = this.model.ratePlan.id;
      let obRatePlan: RatePlanModel | undefined = undefined;
      obRatePlan = this.model.ratePlanOptions.find(
        (x) =>
          this.model &&
          x.status &&
          x.minStay <= fresh.numberOfNights &&
          (x.maxStay >= fresh.numberOfNights || x.maxStay === 0) &&
          x.minPersons <= numberOfPeople &&
          x.maxPersons >= numberOfPeople &&
          x.ratePlanId === currentMainRatePlanId
      );

      if (!obRatePlan) {
        obRatePlan = this.model.ratePlanOptions.find(
          (x) =>
            this.model &&
            x.status &&
            x.isDefault &&
            x.ratePlanId === currentMainRatePlanId
        );
      }

      if (
        obRatePlan &&
        obRatePlan.id !== this.model.ratePlan.ratePlansAccomodationUnitTypeId
      ) {
        this.changeRatePlan({
          ratePlansAccomodationUnitTypeId: obRatePlan.id,
          updateOtherUnits: false,
          autoPriceRecalculation: true,
          inputPriceRecalculationOnly:
            this.reservationModel?.isChannexIdPresent ?? false,
        });
      }
    }
  }

  @Watch("feeCalculationFactors")
  recalculated(fresh: any, old?: any) {
    if (
      _.isEqual(fresh, old) ||
      old.comission === null ||
      old.totalPrice === null ||
      old.comission === undefined ||
      old.totalPrice === undefined
    ) {
      return;
    }
    this.$emit("recalculateAgencyFees", this.model);
  }

  get unitLineOne() {
    if (
      this.renderTemplateTypeLineOne === "" &&
      this.renderTemplateTypeLineTwo === ""
    ) {
      return this.model?.propertyName;
    }

    return this.$t(this.renderTemplateTypeLineOne ?? "", this.renderProps);
  }

  get unitLineTwo() {
    if (
      this.renderTemplateTypeLineOne === "" &&
      this.renderTemplateTypeLineTwo === ""
    ) {
      return (
        this.model?.accomodationUnitTypeName +
        (this.model?.accomodationUnitName
          ? ", " + this.model?.accomodationUnitName
          : "")
      );
    }

    return this.$t(this.renderTemplateTypeLineTwo ?? "", this.renderProps);
  }

  get renderProps() {
    return {
      unitName: this.model?.accomodationUnitName,
      unitTypeName: this.model?.accomodationUnitTypeName,
      propertyName: this.model?.propertyName,
    };
  }

  get showDiscount() {
    return !this.reservationHideDiscount;
  }

  currencyConversionService?: CurrencyConversionService;
  async created() {
    const promises = [];

    if (!this.financialSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }
    if ((this.salesChannels?.length ?? 0) === 0 && this.refreshSalesChannels) {
      this.refreshSalesChannels();
    }

    await Promise.all(promises);

    if (this.financialSettings && this.currencyConversionService == undefined) {
      this.currencyConversionService = currencyConversionServiceFactory(
        this.financialSettings
      );
    }
  }

  mounted() {
    if (
      !this.model?.id &&
      !this.isFromCalendar &&
      !this.isFromAvailabilitySearch
    ) {
      this.unitNumberOfAdultsChanged(
        {
          numberOfAdults: this.model?.numberOfAdults ?? 0,
          numberOfChildren: this.model?.numberOfChildren ?? 0,
          numberOfNights: this.model?.numberOfNights ?? 0,
        },
        undefined
      );
    }
    this.$emit("clearRestrictions");
  }

  get unitCurrencyId() {
    return (
      this.model?.ratePlan?.currencyId ??
      this.financialSettings?.workingCurrency.id
    );
  }

  get tenantUsesServiceType() {
    const param = this.appParams?.find(
      (x) => x.id == AppParamsEnum.ReservationTenantUsesServiceTypes
    );
    return param && param.value;
  }

  get sumGuests() {
    let suma = 0;
    if (this.model)
      suma = this.model.numberOfAdults + this.model.numberOfChildren;
    return suma;
  }

  get renderAddOnServices() {
    return (
      ((this.model?.availableServices?.length ?? 0) ||
        (this.model?.selectedServices?.length ?? 0)) &&
      !this.isOwnerLevel3
    );
  }

  pricePerNightInput() {
    if (this.model) {
      this.model.userSetPricePerNightManually = true;
      this.model.manuallyChangedRatePlan = true; // lock rate plan so user doesn't change price by accident (ex: changing adults)
      this.model.dayPrices.forEach(
        (x) => (
          (x.price =
            (this.model?.pricePerNight ?? 0) - this.mergedCityTaxPricePerDay),
          (x.mergedCityTaxAmount = this.mergedCityTaxPricePerDay)
        )
      );
      //if owner level 3 is changing prices manually, all prices should be the same
      if (this.isOwnerLevel3) {
        this.model.dayPrices.forEach(
          (x) =>
            (x.inputPrice =
              (this.model?.pricePerNight ?? 0) - this.mergedCityTaxPricePerDay)
        );
      }
    }
  }

  discountInput() {
    if (this.isOwnerLevel3 && this.model) {
      this.model.discountInputPercent = this.model.discountPercent;
    }
  }

  inputPricePerNight() {
    if (this.model && this.model.dayPrices) {
      const totalInputPrice = this.model.dayPrices.reduce((total, dayPrice) => {
        return total + dayPrice.inputPrice;
      }, 0);

      return round(totalInputPrice / this.model.dayPrices.length, 2);
    }
  }

  recalculateDayPricesWithCityTax() {
    if (this.model) {
      this.model.dayPrices.forEach(
        (x) => (
          (x.price =
            x.price -
            this.mergedCityTaxPricePerDay +
            (x.mergedCityTaxAmount ?? 0)),
          (x.mergedCityTaxAmount = this.mergedCityTaxPricePerDay)
        )
      );
    }
  }

  servicesListChanged() {
    if (
      this.model &&
      this.serviceTypes?.find(
        (x) => x.id == _.first(this.model?.dayPrices)?.serviceTypeId
      )?.includesCityTax
    ) {
      this.recalculateDayPricesWithCityTax();
    }
  }

  @Watch("model.discountPercent")
  discountWatch() {
    if (this.model?.discountPercent?.toString() === "") {
      this.model.discountPercent = null;
    }
  }

  @Watch("model.discountInputPercent")
  discountInputWatch() {
    if (this.model?.discountInputPercent?.toString() === "") {
      this.model.discountInputPercent = null;
    }
  }

  get warnings() {
    const warnings = [] as string[];

    if (this.model?.numberOfAdults == 0 && this.model?.numberOfChildren == 0) {
      warnings.push("Reservation.Warning.UnitNoGuestsSet");
    }

    if (this.model?.selectedServices.some((x) => x.decimalQuantity == 0)) {
      warnings.push("Reservation.Warning.UnitAddOnServiceQuantity0");
    }

    if (
      this.model?.accomodationUnitId &&
      this.isOverbooked?.includes(this.model?.accomodationUnitId)
    ) {
      warnings.push("AccommodationUnit.Overbooked");
    }

    if (
      this.model?.accomodationUnitId &&
      this.isNotAvailable?.includes(this.model?.accomodationUnitId)
    ) {
      warnings.push("Reservation.Warning.UnitNotAvailable");
    }

    return warnings;
  }

  get errors() {
    const errors = [] as string[];

    if (!this.model?.ratePlan) {
      errors.push("Reservation.Error.UnitRatePlanMustMeSelected");
    }

    if (
      this.model?.childrenAges.some(
        (x) => x == undefined || x == null || x.toString() == "" || x < 0
      )
    ) {
      errors.push("Reservation.Error.UnitAllChildrenAgesMustBeSet");
    }

    if (
      this.model &&
      (this.model?.numberOfAdults < 0 || this.model?.numberOfChildren < 0)
    ) {
      errors.push("Reservation.Error.GuestValuaCannotBeNegative");
    }

    if (
      this.unitCurrencyId !==
      this.reservationModel?.accomodationUnitTypes[0].ratePlan?.currencyId
    ) {
      errors.push(
        "Reservation.Error.UnitMustHaveRatePlanWithSameCurrencyAsTheReservation"
      );
    }

    // owner's reservation checks
    // unit must have an owner
    if (
      this.reservationModel &&
      this.reservationModel.distributionChannelTypeId ===
        DistributionChannelEnum.OwnersReservation &&
      this.model &&
      getUnitOwnerIds(this.model).length === 0
    ) {
      errors.push(
        "Reservation.OwnersReservation.Validation.UnitsMustHaveAnOwner"
      );
    }

    // all units on the reservation must have the same owner
    if (
      this.reservationModel &&
      this.reservationModel.distributionChannelTypeId ===
        DistributionChannelEnum.OwnersReservation &&
      this.model &&
      !this.hasCommonOwner
    ) {
      errors.push(
        "Reservation.OwnersReservation.Validation.UnitsMustHaveSameOwner"
      );
    }
    return errors;
  }

  get hasCommonOwner() {
    if (!this.reservationModel || !this.model) return false;

    const allUnits = this.reservationModel.accomodationUnitTypes;
    const allOwners = _.uniq(allUnits.flatMap((x) => getUnitOwnerIds(x)));

    const unitsByOwner = [] as {
      ownerId: number;
      units: ReservationAccUnitModel[];
    }[];
    allOwners.forEach((x) => {
      unitsByOwner.push({
        ownerId: x,
        units: allUnits.filter((e) => getUnitOwnerIds(e).includes(x)),
      });
    });

    return unitsByOwner.some(
      (o) => !allUnits.some((e) => !o.units.includes(e))
    );
  }

  @Getter("appParams/reservationFormBlankPriceOption")
  reservationFormBlankPriceOption?: boolean;
  exportRegistrationFormDialogShown = false;
  exportRegistrationFormClickHandler() {
    if (!this.reservationFormBlankPriceOption) {
      this.exportRegistrationForm({ reservationFormBlankPrice: false });
      return;
    } else {
      this.exportRegistrationFormDialogShown = true;
    }
  }

  exportRegistrationFormDialogYes() {
    this.exportRegistrationForm({ reservationFormBlankPrice: false });
    this.exportRegistrationFormDialogShown = false;
  }
  exportRegistrationFormDialogNo() {
    this.exportRegistrationForm({ reservationFormBlankPrice: true });
    this.exportRegistrationFormDialogShown = false;
  }

  exportingRegistrationForm = false;
  async exportRegistrationForm(options: ExportRegistrationFormOptions) {
    this.exportingRegistrationForm = true;
    await this.$http
      .get(`reservations/export/RegistrationForm/${this.model?.id}`, {
        responseType: "blob",
        params: {
          blankPrices: options.reservationFormBlankPrice,
        },
      })
      .then((res) => {
        const ext = "pdf";
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;

        saveFile(
          res.data,
          groups?.filename ?? `RegistrationForm_${this.model?.id}.${ext}`
        );
      })
      .finally(() => {
        this.exportingRegistrationForm = false;
      });
  }

  get servicesPrice() {
    const isAllowedOnlyInputPrices = policyChecker("INPUT_PRICES")(this.claims);
    if (this.currencyConversionService == undefined) {
      if (this.financialSettings) {
        this.currencyConversionService = currencyConversionServiceFactory(
          this.financialSettings
        );
      }
    }
    if (!isAllowedOnlyInputPrices) {
      return (
        this.model?.selectedServices.reduce((sum, s) => {
          return (
            sum +
            (this.currencyConversionService?.convertCurrency(
              s.grossPrice,
              s.currencyId,
              this.unitCurrencyId ?? s.currencyId
            ) ?? s.grossPrice)
          );
        }, 0) ?? 0
      );
    } else {
      return this.model?.ownerAddOnServicesPrice ?? 0;
    }
  }

  get totalPrice() {
    let totalDayPrices = 0;

    if (this.model && this.model.dayPrices) {
      totalDayPrices = this.model.dayPrices.reduce(
        (sum, e) => sum + e.price,
        0
      );
    }

    if (this.model && this.model.discountPercent) {
      totalDayPrices = round(
        totalDayPrices * (1 - this.model.discountPercent / 100),
        2
      );
    }

    return totalDayPrices + this.servicesPrice;
  }

  get mergedCityTaxPricePerDay() {
    let totalCityTaxPrice = 0;
    if (this.model && this.model.selectedServices) {
      totalCityTaxPrice =
        this.model.selectedServices
          .filter((x) => x.isCityTax)
          .reduce(
            (sum, e) =>
              this.serviceTypes?.find(
                (x) => x.id == _.first(this.model?.dayPrices)?.serviceTypeId
              )?.includesCityTax === true
                ? sum +
                  (this.currencyConversionService?.convertCurrency(
                    e.grossPrice,
                    e.currencyId,
                    this.unitCurrencyId ?? e.currencyId
                  ) ?? e.grossPrice)
                : sum,
            0
          ) || 0;
    }

    return round(
      totalCityTaxPrice / (this.numberOfNights > 0 ? this.numberOfNights : 1),
      2
    );
  }

  get numberOfNights() {
    if (this.model?.arrivalDate && this.model?.departureDate) {
      const numberOfNights = differenceInDays(
        new Date(this.model.arrivalDate),
        new Date(this.model.departureDate)
      );
      return isFinite(numberOfNights) && numberOfNights > 0
        ? numberOfNights
        : 1;
    } else {
      return 0;
    }
  }

  get rules() {
    return {
      required: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
    };
  }

  countDecimals(num: number) {
    return num?.toString().split(".")[1]?.length || 0;
  }

  @Getter("auth/claims") claims?: JwtClaims;
  get canEditPrices() {
    return (
      policyChecker("MODIFY_RESERVATION_PRICES")(this.claims) ||
      (policyChecker("OWNER_LEVEL_3")(this.claims) &&
        this.reservationModel?.distributionChannelTypeId ===
          DistributionChannelEnum.OwnersReservation)
    );
  }

  get reservationIsReadonly() {
    if (
      (policyChecker("OWNER_LEVEL_3")(this.claims) &&
        this.reservationModel?.distributionChannelTypeId ===
          DistributionChannelEnum.OwnersReservation) ||
      !policyChecker("OWNER_LEVEL_3")(this.claims)
    ) {
      return false;
    }
    return true;
  }

  get isOwnerLevel3() {
    return policyChecker("OWNER_LEVEL_3")(this.claims);
  }

  ratePlanSelectOpen = false;
  availableRatePlans: any[] = [];

  openRatePlanSelect(model: ReservationAccUnitModel) {
    const ratePlanOptions = model.ratePlanOptions.filter((x) => x.status);
    const numberOfGuests =
      model.numberOfAdults +
      (this.childrenAffectPAXRatePlanSelection ? model.numberOfChildren : 0);

    let options = [] as RatePlanModel[];

    options = ratePlanOptions.filter(
      (x) =>
        x.minStay <= this.numberOfNights &&
        (x.maxStay >= this.numberOfNights || x.maxStay === 0) &&
        x.minPersons <= numberOfGuests &&
        x.maxPersons >= numberOfGuests
    );

    options.push(
      ...ratePlanOptions.filter(
        (x) => x.isDefault && !options.some((e) => e.ratePlanId == x.ratePlanId)
      )
    );

    const standaloneRatePlans = options
      .filter((x) => !x.isDerived)
      .sort((a, b) => a.name.localeCompare(b.name));
    const derivedRatePlans = options
      .filter((x) => x.isDerived)
      .sort((a, b) => a.name.localeCompare(b.name));

    const sortedRatePlans: RatePlanModel[] = [];

    for (const standaloneRatePlan of standaloneRatePlans) {
      sortedRatePlans.push(standaloneRatePlan);

      const derivedRates = derivedRatePlans.filter(
        (x) => x.parentRatePlanId === standaloneRatePlan.ratePlanId
      );

      for (const derivedRate of derivedRates) {
        sortedRatePlans.push(derivedRate);
      }
    }

    this.availableRatePlans = sortedRatePlans;
    this.ratePlanSelectOpen = true;
  }

  changeRatePlanFromModal(event: ChangeRatePlanEvent) {
    if (
      this.model &&
      event.ratePlansAccomodationUnitTypeId !=
        this.model.ratePlan?.ratePlansAccomodationUnitTypeId
    ) {
      this.model.manuallyChangedRatePlan = true;
    }
    this.changeRatePlan(event);
  }

  changeRatePlan(event: ChangeRatePlanEvent) {
    if (this.model) {
      const ratePlan = this.model.ratePlanOptions.find(
        (x) => x.id === event.ratePlansAccomodationUnitTypeId
      );
      if (ratePlan) {
        this.model.ratePlansAccomodationUnitTypeId = ratePlan.id;
        this.model.ratePlan = {
          id: ratePlan.ratePlanId,
          ratePlansAccomodationUnitTypeId: ratePlan.id,
          name: ratePlan.name,
          parentRatePlanId: ratePlan.parentRatePlanId,
          currencyId: ratePlan.currencyId,
          accomodationBookingFee: ratePlan.accomodationBookingFee,
          addOnServicesBookingFee: ratePlan.addOnServicesBookingFee,
          mergeAllBookingFeesIntoSingleItem:
            ratePlan.mergeAllBookingFeesIntoSingleItem,
        } as SelectedRatePlanModel;
      }
    }

    this.$emit("changedRatePlan", {
      model: this.model,
      updateOtherUnits: event.updateOtherUnits,
      autoPriceRecalculation: event.autoPriceRecalculation,
      inputPriceRecalculationOnly: event.inputPriceRecalculationOnly,
    });
  }

  get everyServiceTypeIsTheSame() {
    const serviceTypeIds = this.model?.dayPrices.map((x) => x.serviceTypeId);
    return serviceTypeIds?.every((x) => x == _.first(serviceTypeIds));
  }

  get everyDayPriceIsTheSame() {
    const dayPrices = this.model?.dayPrices.map((x) => x.price);
    return dayPrices?.every((x) => x == _.first(dayPrices));
  }

  get serviceTypeName() {
    const serviceTypeIds = this.model?.dayPrices.map((x) => x.serviceTypeId);
    if (serviceTypeIds?.every((x) => x == _.first(serviceTypeIds))) {
      return (
        this.serviceTypes?.find((x) => x.id == _.first(serviceTypeIds))?.name ??
        this.$t("ServiceType.NotAssigned").toString()
      );
    } else {
      return this.$t("ServiceType.MixedServiceTypes").toString();
    }
  }

  selectedServiceType: number | null = null;
  serviceTypeSelectOpen = false;

  openServiceTypeSelect() {
    this.serviceTypeSelectOpen = true;
    this.selectedServiceType =
      _.first(this.model?.dayPrices)?.serviceTypeId ??
      this.model?.ratePlanOptions.find(
        (x) => x.ratePlanId == this.model?.ratePlan?.id
      )?.defaultServiceTypeId ??
      null; // if tenant uses service types there WILL be a default service type
  }

  changeServiceType(event: ChangeServiceTypeEvent) {
    if (this.model) {
      this.model.dayPrices.forEach((x) => {
        x.serviceTypeId = event.serviceTypeId;
      });
      this.recalculateDayPricesWithCityTax();
    }

    this.$emit("changedServiceType", {
      model: this.model,
      updateOtherUnits: event.updateOtherUnits,
    });
  }

  get unitStatus() {
    return reservationStatuses.find((x) => x.id == this.model?.statusId);
  }

  get showStatusIcon() {
    return (
      policyChecker("UNIT_STATUS")(this.claims) &&
      this.model?.accomodationUnitStatus != AccomodationUnitStatusEnum.Clean
    );
  }

  getStatusColor() {
    switch (this.model?.accomodationUnitStatus) {
      case AccomodationUnitStatusEnum.NeedsCleaning:
        return ["orange-text"];
      case AccomodationUnitStatusEnum.NeedsRepair:
        return ["red-text"];
      case AccomodationUnitStatusEnum.CleaningInProgress:
        return ["orange-text"];
      case AccomodationUnitStatusEnum.RepairInProgress:
        return ["red-text"];
      default:
        return [""];
    }
  }

  getStatusIcon() {
    switch (this.model?.accomodationUnitStatus) {
      case AccomodationUnitStatusEnum.NeedsCleaning:
        return "fa-vacuum";
      case AccomodationUnitStatusEnum.NeedsRepair:
        return "fa-tools";
      case AccomodationUnitStatusEnum.CleaningInProgress:
        return "fa-sync";
      case AccomodationUnitStatusEnum.RepairInProgress:
        return "fa-sync";
      default:
        return "";
    }
  }

  getRateName(rate: SelectedRatePlanModel) {
    let paxSuffix = "";
    let losSuffix = "";
    if (this.showPAXSuffixInRatePlanName) {
      paxSuffix =
        rate.minPersons === rate.maxPersons
          ? `, ${rate.minPersons} pax`
          : `, ${rate.minPersons}-${rate.maxPersons} pax`;
    }
    if (this.showLOSSuffixInRatePlanName) {
      losSuffix =
        rate.maxStay === 0
          ? `, ${rate.minStay}+ LOS`
          : rate.minStay === rate.maxStay
          ? `, ${rate.minStay} LOS`
          : `, ${rate.minStay}-${rate.maxStay} LOS`;
    }
    return `${rate.name}${paxSuffix}${losSuffix}`;
  }
}
